const getBaseUrl = () => {
    const authURL = process.env.REACT_APP_NODE_ENV === 'DEV' ? process.env.REACT_APP_BASE_URL_DEV : process.env.REACT_APP_BASE_URL_PROD;
    return authURL;
}

export {
    getBaseUrl,
}